(function (window, document, $) {

    $(document).ready(function () {
        // Responsive videos  ==========================================================================================

        function responsive_vid() {
            var content = document.querySelector('.editor-content');

            if (content != null) {
                if (content.hasOwnProperty('childNodes')) {
                    content.childNodes.forEach(function (tag) {
                        tag.childNodes.forEach(function (element) {
                            if (element.nodeName === "IFRAME") {
                                element.parentNode.className = 'embed-responsive-16by9 embed-responsive';
                            }
                        });
                    });
                }
            }
        }

        responsive_vid();
    });

}(window, document, jQuery));
